module.exports = __webpack_public_path__ + "static/media/privacy.a603b73f.pdf";